var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { MarketIdToMarketType } from "../data";
import { observable, action, observe } from "mobx";
import * as C from "../contracts";
export class Retriever {
    constructor(props) {
        this.subscribeOutrightEvent = (outright) => {
            if (outright.eventIds.length) {
                this.outrightSportConnection.updateQuery(outright.eventIds);
            }
        };
        this.subscribeFixtureEvent = (fixture) => {
            if (fixture.eventIds.length) {
                this.fixtureSportConnection.updateQuery(fixture.eventIds, [{ marketTypeIds: fixture.marketTypeIds }]);
            }
        };
        this.dataCollection = C.defaultDataCollection;
        this.fixtureSportConnection = props.fixtureSportConnection;
        this.outrightSportConnection = props.outrightSportConnection;
        this.sportConnectionDisposer = [];
        this.shouldRemoveEvents = false;
        this.outright = { eventIds: props.eventIds.Outrights };
        this.fixture = {
            eventIds: props.eventIds.All.filter(id => !props.eventIds.Outrights.includes(id)),
            marketTypeIds: Object.keys(MarketIdToMarketType)
        };
    }
    activate() {
        this.sportConnectionDisposer.push(observe(this.fixtureSportConnection, "sportResponse", (change) => this.onUpdate(change.newValue)));
        this.sportConnectionDisposer.push(observe(this.outrightSportConnection, "sportResponse", (change) => this.onUpdate(change.newValue)));
        this.sportConnectionDisposer.push(observe(this.fixtureSportConnection, "error", this.onError));
        this.sportConnectionDisposer.push(observe(this.outrightSportConnection, "error", this.onError));
        this.subscribeFixtureEvent(this.fixture);
        this.subscribeOutrightEvent(this.outright);
    }
    deactivate() {
        this.sportConnectionDisposer.map(dispose => dispose());
        this.fixtureSportConnection.deactivate();
        this.outrightSportConnection.deactivate();
    }
    onPushResponse(data) {
        const updateType = data.updateType.toLowerCase();
        this.updateData(updateType, data.payload);
    }
    onPullResponse(data) {
        this.updateData("add", data);
    }
    onUpdate(payload) {
        if ("updateType" in payload) {
            this.onPushResponse(payload);
        }
        else {
            this.onPullResponse(payload);
        }
    }
    updateData(updateType, data) {
        this.dataCollection = Object.assign(Object.assign({}, C.defaultDataCollection), {
            [updateType]: data
        });
    }
    onError() {
        this.shouldRemoveEvents = true;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Retriever.prototype, "dataCollection", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], Retriever.prototype, "shouldRemoveEvents", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "updateData", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "onError", null);
//# sourceMappingURL=Retriever.js.map